import React from "react";

import Paper from "@material-ui/core/Paper";
import TablePagination from "@mui/material/TablePagination";

import jwtInterceptor from "../service/jwtInterceptor";
import TableRowUser from "../component/TableRowUser";
import {API_URL} from "../utils/constants";
import {Helmet} from "react-helmet";
import CustomBtn from "../component/customBtns/CustomBtn";
import {Box} from "@mui/material";
import Modal from "@mui/material/Modal";
import {InscriptionCollaborateur} from "../component/users/InscriptionCollaborateur";

class UserContainer extends React.Component {
    DEFAULT_PER_PAGE = 10;
    DEFAULT_PAGE = 0;

    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            dataTable: [],
            page: this.DEFAULT_PAGE,
            rowsPerPage: this.DEFAULT_PER_PAGE,
            openCreateCollaboModal: false,
            selectedUser: null,
        };
    }

    handleEditUser = (user) => {

        this.setState({
            selectedUser: user,
            openCreateCollaboModal: true,
        }, () => {
            console.log('État après mise à jour:', this.state.selectedUser);
        });
    };


    setOpenCreateCollaboModal = (value) => {
        this.setState((prevState) => ({
            ...prevState,
            openCreateCollaboModal: value,
        }));
    };
    colums = [
        {accessor: "username", show: "Nom"},
        {accessor: "firstname", show: "Prenom"},
        {accessor: "typeUser", show: "Type"},
        {accessor: "email", show: "E-mail"},
        {accessor: "createdAt", show: "Date inscription"},
        {accessor: "updatedAt", show: "Date dernier login"},
    ];
    admin_columns = [
        {accessor: "username", show: "Nom"},
        {accessor: "firstname", show: "Prenom"},
        {accessor: "agence", show: "Agence"},
        {accessor: "email", show: "E-mail"},
        {accessor: "createdAt", show: "Date inscription"},
        {accessor: "updatedAt", show: "Date dernier login"},
    ];

    handleChangePage = (event, newPage) => {
        this.setState((prevState) => {
            return {...prevState, page: newPage};
        });
        this.getData(this.state.rowsPerPage, newPage);
    };

    handleChangeRowsPerPage = (event) => {
        this.setState((prevState) => {
            return {...prevState, rowsPerPage: parseInt(event.target.value)};
        });
        this.getData(event.target.value, this.state.page);
    };

    getData = (perPage, page) => {
        this.searchfn({
            size: perPage,
            page: page,
        });
    };

    componentDidMount() {
        this.getData(this.DEFAULT_PER_PAGE, this.DEFAULT_PAGE);
    }

    searchfn = (filter) => {
        jwtInterceptor
            .get(
                `${API_URL}/user/agencies-users?size=${filter.size}&page=${filter.page}`
            )
            .then((res) => {
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        total: res.data.data.total,
                        dataTable: res.data.data.results,
                    };
                });
            });
    };

    onClickCreateUser($event) {
        $event.target.stopPropagation();
        this.setOpenCreateCollaboModal(true);
    }


    onCloseCreateUser = () => {
        this.setState({
            openCreateCollaboModal: false,
            selectedUser: null,
        });
        this.getData(this.DEFAULT_PER_PAGE, this.DEFAULT_PAGE);
    };

    render() {
        /****Custom variable styles */
        const fontWeightTitle = {
            fontWeight: "600",
        };
        return (
            <div className="my-4 px-4">
                <Helmet>
                    <title>Gérer les utilisateurs - Mixdata</title>
                </Helmet>
                <Paper className="py-4 px-4 rounded shadow-none App-container sw-100 m-0">
                    <div className="d-flex justify-content-between">
                        <h3
                            className="mb-4"
                            style={{...fontWeightTitle, width: "fit-content"}}
                        >
                            Collaborateur(s)
                        </h3>
                        <div style={{width: "fit-content"}}>
                            <CustomBtn
                                label="Collaborateur"
                                bgColor="#299CDB"
                                iconBg={"#3ba9e5"}
                                icon={"+"}
                                click={() => this.setOpenCreateCollaboModal(true)}
                            />
                            {/* <Image src={FilterIcon} className="fluid ms-3 pointer"></Image> */}
                        </div>
                    </div>
                    <div className="overflow-auto">
                        <table className="table" style={{margin: "auto"}}>
                            <thead
                                style={{
                                    background: "#eeeeee",
                                    borderBottom: "2px #DEE2E6 solid",
                                    fontWeight: "normal",
                                    color: "#363636",
                                    marginBottom: "5px",
                                }}
                            >
                            <tr style={{width: "100%"}}>
                                {this.colums.map((field) => {
                                    return (
                                        <th
                                            style={{width: "16.66%"}}
                                            scope="col"
                                            key={field.accessor}
                                        >
                                            {field.show}
                                        </th>
                                    );
                                })}
                                <th style={{width: "7.66%"}} scope="col" key={"actions"}>
                                    Action
                                </th>
                            </tr>
                            </thead>
                            <tbody style={{paddingInline: "5px"}}>
                            {this.state.dataTable.map((row, index) => (
                                <TableRowUser
                                    key={row._source.id}
                                    keyIndex={index}
                                    row={row}
                                    onEdit={() => this.handleEditUser(row)}
                                />
                            ))}
                            </tbody>
                        </table>
                    </div>
                    <TablePagination
                        component="div"
                        count={this.state.total}
                        page={
                            !this.state.page || this.state.page <= 0 ? 0 : this.state.page
                        }
                        onPageChange={this.handleChangePage}
                        rowsPerPage={this.state.rowsPerPage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                        labelRowsPerPage="Lignes par page"
                        backIconButtonProps={{
                            "aria-label": "Précédent",
                            className: "PreviousBtn",
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Suivant",
                            className: "NextBtn",
                        }}
                    />
                    <div class="admin_side">
                        <div className="d-flex justify-content-between">
                            <h3
                                className="mb-4"
                                style={{...fontWeightTitle, width: "fit-content"}}
                            >
                                Administrateur d'agence
                            </h3>
                        </div>
                        <div className="overflow-auto">
                            <table className="table" style={{margin: "auto"}}>
                                <thead
                                    style={{
                                        background: "#eeeeee",
                                        borderBottom: "2px #DEE2E6 solid",
                                        fontWeight: "normal",
                                        color: "#363636",
                                        marginBottom: "5px",
                                    }}
                                >
                                <tr style={{width: "100%"}}>
                                    {this.admin_columns.map((field) => {
                                        return (
                                            <th
                                                style={{width: "16.66%"}}
                                                scope="col"
                                                key={field.accessor}
                                            >
                                                {field.show}
                                            </th>
                                        );
                                    })}
                                </tr>
                                </thead>
                                <tbody style={{paddingInline: "5px"}}>
                                {this.state.dataTable.map((row, index) => (
                                    <TableRowUser
                                        userType="admin"
                                        key={row._source.id}
                                        keyIndex={index}
                                        row={row}
                                    />
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Modal
                        open={this.state.openCreateCollaboModal}
                        onClose={this.onCloseCreateUser}
                    >
                        <Box
                            className="w-50 h-auto rounded p-3"
                            style={{height: "fit-content"}}
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                bgcolor: "background.paper",
                                boxShadow: 24,
                                p: 4,
                            }}
                        >
                            <InscriptionCollaborateur
                                onSubmitted={this.onCloseCreateUser}
                                userToEdit={this.state.selectedUser}
                            ></InscriptionCollaborateur>
                        </Box>
                    </Modal>
                </Paper>

            </div>
        );
    }
}

export default UserContainer;
